import React, { useState } from 'react';

const NavigationWrapper = ({ children }) => {
  const [showTrivia, setShowTrivia] = useState(false);
  return children(showTrivia, setShowTrivia);
};

export default NavigationWrapper; 